import { type ThemeColors } from "../lib/theme";
import type { ReactNode } from "react";

interface SectionHeaderProps {
  icon: ReactNode;
  title: string;
  theme: ThemeColors;
  isDark: boolean;
  onClick?: () => void;
}

export function SectionHeader({ icon, title, theme, onClick }: SectionHeaderProps) {
  return (
    <div className="flex items-center gap-3" onClick={onClick}>
      <div
        className={`w-8 h-8 -rotate-3 rounded-lg border-2 border-ink shadow-board-sm flex items-center justify-center ${theme.iconBg} ${theme.iconText}`}
      >
        {icon}
      </div>
      <h3 className={`font-display text-sm uppercase tracking-wide ${theme.text}`}>
        {title}
      </h3>
    </div>
  );
}
